/* eslint-disable */

import dropWhite from '../../../resource/icons/ic_bevo_drop_16.svg';
import './header_overwrite.css';
import './header.css';
import '../../../globals/style/GlobalStyle.css';
import {useTranslation} from 'react-i18next';
import {NavWeb} from './subcomponent/navWeb/NavWeb';
import {SearchOverview} from '../search/SearchOverview';
import {Link} from 'react-router-dom';
import {openCategoriesMenu, closeCategoriesMenu, showProviderTab} from '../../../utility/DialogHelper';


const LANGUAGES = ['de', 'en', 'pt'];

export default function Header() {
    const {t, i18n} = useTranslation();

    const languageClass = (lang, mobile = false) =>
        [
            'wb-language-menu__item',
            mobile && 'mobileLanguageItem',
            i18n.language === lang &&
            'wb-language-menu__item--active',
        ]
            .filter(Boolean)
            .join(' ');

    const renderLanguageItems = (mobile = false) => LANGUAGES.map(
        (lang) => (
            <a key={`${mobile ? 'mobile' : 'desktop'}-${lang}`} onClick={() => i18n.changeLanguage(lang)} className={languageClass(lang, mobile)}>
                <div className='wb-language-menu__item-inner'>
                    <span>{lang.toUpperCase()}</span>
                </div>
            </a>
        )
    );

    const openSearch = (e) => {
        e.preventDefault();
        closeCategoriesMenu();

        document.getElementsByClassName('wb-header__logo-container')[0]?.classList.add('foreground');

        document.getElementById('searchContainer')?.classList.add('visible');

        document.getElementById('searchContainer')?.classList.remove('notVisible');

        document.getElementById('deactivedBackground')?.classList.add('visible');
        document.getElementById('deactivedBackground')?.classList.add('darkColor');

        document.getElementById('deactivedBackground')?.classList.remove('notVisible');
    };

    return (<>
        <SearchOverview/>
        <div className='headerContainer'>
            <wb-headers logo-href='/'>
                <div className="wb-header__content-width">
                    <div className="wb-header__logo-container">
                        <a className="wb-header__logo" href="/">
                            <img src="/MB-star_n_2D_3Cweb.svg" className="wb-header__star"/>
                            <div className="wb-header__claim-wrapper">
                                <img src="/MB-word-mark_trucks-claim_la_S_n_3Coffice.png" className="wb-header__claim"/>
                            </div>
                        </a>
                    </div>
                    <div className="wb-header__nav-container" role="navigation">
                        <nav className='wb-header-nav wb-header-nav--desktop wb-header-nav--meta'
                             aria-label='Meta Navigation'>
                            <div className='wb-language-menu foreground'>
                                {renderLanguageItems()}
                            </div>
                            <button className='wb-header-nav__control wb-header-nav__control--icon-only' type='button'
                                    onClick={openSearch}>
                                <wb-icon name='search' aria-hidden='true'></wb-icon>
                                <span className='wb-visually-hidden'>ADD BUTTON TEXT</span>
                            </button>
                        </nav>
                        <nav className='wb-header-nav wb-header-nav--desktop wb-header-nav--main'
                             aria-label='Main Navigation (First Level)'>
                            <button className='wb-header-nav__control wb-header-nav__control--offset-start'
                                    type='button' onClick={openCategoriesMenu}>
                                <wb-icon src={dropWhite} aria-hidden='true'></wb-icon>
                                {t('Categories')}
                            </button>
                            {/*}
                            <a className='wb-header-nav__control ' href={i18n.language === 'en' ? "/DTFR_Overview.pdf" : i18n.language === 'pt' ? "/DTFR_Visão_geral.pdf" : "/DTFR_Übersicht.pdf"} target='_blank'>
                                {t('MappingOverview')}
                            </a>
                            {*/}
                            <Link className='wb-header-nav__control' to='/oil-finder'>
                                {t('OilFinder')}
                            </Link>
                            <a className='wb-header-nav__control' onClick={showProviderTab} target='_blank'>
                                {t('Provider')}
                            </a>
                            <Link className='wb-header-nav__control' to='/contact'>
                                {t('Contact')}
                            </Link>
                        </nav>
                        <nav className='wb-header-nav wb-header-nav--tablet wb-header-nav--start'
                             aria-label='Main Navigation'>
                            <button className='wb-header-nav__control wb-header-nav__control--icon-only' type='button'
                                    onClick={openCategoriesMenu}>
                                <wb-icon src={dropWhite} aria-hidden='true'></wb-icon>
                                <span className='wb-visually-hidden'>Categories</span>
                            </button>
                        </nav>
                        <nav className='wb-header-nav wb-header-nav--mobile wb-header-nav--start mobileHeader'
                             aria-label='Main Navigation Controls'>
                            <button className='wb-header-nav__control wb-header-nav__control--icon-only' type='button'
                                    onClick={openCategoriesMenu}>
                                <wb-icon src={dropWhite} aria-hidden='true'></wb-icon>
                                <span className='wb-visually-hidden'>Kategorien</span>
                            </button>
                        </nav>
                        <div className='wb-language-menu foreground mobileLanguageSwitch notDesktop' aria-label='Language Navigation'>
                            {renderLanguageItems(true)}
                        </div>

                        <button className='wb-header-nav__control wb-header-nav__control--icon-only notDesktop'
                                type='button' onClick={openSearch}>
                            <wb-icon name='search' aria-hidden='true'></wb-icon>
                            <span className='wb-visually-hidden'>ADD BUTTON TEXT</span>
                        </button>
                    </div>
                </div>
            </wb-headers>
            <NavWeb/>
        </div>
    </>);
}
